module.exports = __webpack_public_path__ + "media/1x1/gi-b0015a50.svg";